<mat-card *ngIf="post" [@doubleBlink]="blinkState" class="h-100 blinking-element">
    <div *ngIf="post.is_pinned && showPinnedBadge" class="pinned">
        <mat-icon svgIcon="thumbtackIcon"></mat-icon>
    </div>
    <mat-card-header [style.padding-right]="post.is_pinned && showPinnedBadge? '45px' : ''"
                     class="d-flex gap-5 ">
        <div class="head">
            <ng-container *ngIf="post.author && post.author?.id > 0 else anonymous">
                <div *ngIf="post.author?.is_staff" [matMenuTriggerFor]="menu"
                     (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                     class="moderator clickable"
                     matTooltip="Moderator">
                    <mat-icon>verified_user</mat-icon>
                </div>
                <div [appUserAvatar]="post.author" [matMenuTriggerFor]="menu" class="miniInitial clickable"
                     (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                     mat-card-avatar>{{ post.author.username | slice: 0 : 1 | titlecase }}
                </div>
                <!-- Menu definition -->
                <mat-menu #menu="matMenu" class="userDisplayMenu">
                    <ng-container *ngIf="userInfoMenuOpen">
                        <app-user-info [user]="post.author"></app-user-info>
                    </ng-container>
                </mat-menu>

            </ng-container>
        </div>
        <div [class.flex-1]="showOpenInFeed" [class.titleWidthMinusAvatar]="reducedContent" class="titleSection">
            <mat-card-title>
                <div class="flex-row flex-space-between gap-10 breakWord">
                    <span (click)="viewComments(post)" *ngIf="!showOpenInFeed" class="clickable">
                        {{ post.title }}
                    </span>

                    <ng-container *ngIf="showOpenInFeed">
                        <span (click)="findPostInFeed(post)" [class.ellipsis]="reducedContent"
                              class="clickable">{{ post.title }}</span>
                        <button (click)="findPostInFeed(post)"
                                class="small-icon-button"
                                mat-icon-button
                                matTooltip="Go to the post in the feed">
                            <mat-icon>open_in_new</mat-icon>
                        </button>
                    </ng-container>
                </div>
            </mat-card-title>
            <mat-card-subtitle>{{ post.created_at | relativeTime }}
                <ng-container *ngIf="!reducedContent">
                    <ng-container *ngFor="let category of post?.categories">,
                        <a [queryParams]="{ category:  category?.id }" [routerLink]="['/feed']"
                           [style.color]="category.font_color_hex + ' !important'"
                           class="blackLink">{{ this.community?.member_generated_name && category.name == 'Member Generated' ? this.community?.member_generated_name : category?.name }}
                        </a>
                    </ng-container>
                    <ng-container *ngIf="post.is_closed_loop">
                        ,
                        <a [queryParams]="{ closeTheLoop:  true }" [routerLink]="['/feed']"
                           class="blackLink">{{ this.community?.close_the_loop_name || 'Close The Loop' }}
                        </a>
                    </ng-container>
                </ng-container>
            </mat-card-subtitle>
        </div>
        <div class="flex-row actionSection">
            <mat-icon *ngIf="(post.likes_off || post.dislikes_off || post.comments_off) && !reducedContent"
                      [matTooltip]="'This post is locked and the following features have been disabled: ' +
                  (post.likes_off? 'Likes, ' : '') + (post.dislikes_off? 'Dislikes, ' : '' )+ (post.comments_off? 'Comments ' : '' )">
                lock
            </mat-icon>
            <button (click)="markModerated(post)"
                    *ngIf="(hasCommunityRole(['moderator', 'full_admin']) || isSuperuser) && !hideActions && !post.moderated"
                    aria-label="Mark post as moderated"
                    class="delete-icon-button"
                    mat-icon-button matTooltip="Mark post as moderated">
                <mat-icon color="warn">check_circle</mat-icon>
            </button>
            <button (click)="editPost(post)"
                    *ngIf="(isSuperuser || hasCommunityRole(['full_admin']) || (user && post.author?.id === user?.id)) && !hideActions"
                    aria-label="Edit post" class="edit-icon-button"
                    mat-icon-button matTooltip="Edit post">
                <mat-icon>edit</mat-icon>
            </button>

            <button (click)="deletePost(post.id)"
                    *ngIf="(isSuperuser || hasCommunityRole(['full_admin'])) && !hideActions"
                    aria-label="Delete post" class="delete-icon-button"
                    mat-icon-button matTooltip="Delete post">
                <mat-icon>delete</mat-icon>
            </button>
            <button (click)="toggleEmoji(post)"
                    *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !hideActions && this.selectedCommunity?.emoji_enabled"
                    [matTooltip]="'Toggle ' + (!post?.emoji_enabled ? 'on' : 'off') + ' emoji'"
                    aria-label="Toggle emoji"
                    class="delete-icon-button"
                    mat-icon-button>
                <mat-icon *ngIf="post?.emoji_enabled">face</mat-icon>
                <mat-icon *ngIf="!post?.emoji_enabled">face_retouching_off</mat-icon>
            </button>
            <button (click)="showHeatmapResults(post.heatmap_surveys)"
                    *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'client', 'reports_only', 'observer']) || (hasCommunityRole(['member'])) && post.heatmap_surveys?.[0]?.user_vote) && !hideActions && post.heatmap_surveys?.length"
                    [matTooltip]="'Show heatmap results'"
                    aria-label="Show heatmap results"
                    class="delete-icon-button"
                    mat-icon-button>
                <mat-icon>
                    <mat-icon>scatter_plot</mat-icon>
                </mat-icon>
            </button>
        </div>
    </mat-card-header>
    <mat-card-content [class.reducedContent]="reducedContent">
        <app-post-content *ngIf="!hideMedia" [class.events-none]="isModalActive$ | async"
                          [content]="post"></app-post-content>
        <app-poll-view
                *ngIf="pollId && !hidePoll"
                [forceShowResults]="hasCommunityRole(['client', 'reports_only', 'full_admin', 'observer'])"
                [pollId]="pollId"
                [small]="smallPoll"></app-poll-view>
    </mat-card-content>
    <mat-card-actions [class.flex-end]="(post.comment_authors?.length <= 0 || !post.comment_authors) && !reducedContent"
                      [class.flex-space-between]="post.comment_authors?.length > 0 && !reducedContent"
                      class="flex-wrap">
        <div *ngIf="post.comment_authors?.length > 0 && !reducedContent" class="commentsUsersList">
            <ng-container *ngFor="let commentor of post.comment_authors; let index = index">
                <div *ngIf="index < 4" class="pics d-flex gap-2">
                    <div [appUserAvatar]="commentor" [matTooltip]="commentor?.username"
                         class="miniInitial d-inline-flex small"
                         mat-card-avatar>{{ commentor?.username ? commentor?.username : 'A' | slice: 0 : 1 | titlecase }}
                    </div>
                </div>
            </ng-container>
            <p class="font-14">
                <ng-container *ngIf="post.comment_authors?.length > 4">+{{ post.comment_authors?.length - 4 }}&nbsp;Others
                </ng-container>
                Commented
            </p>
        </div>
        <div [class.flex-space-around]="reducedContent" [class.w-100]="reducedContent"
             class="d-flex gap-5 align-items-center flex-wrap">
            <mat-icon *ngIf="(post.likes_off || post.dislikes_off || post.comments_off) && reducedContent"
                      [matTooltip]="'This post is locked and the following features have been disabled: ' +
                  (post.likes_off? 'Likes, ' : '') + (post.dislikes_off? 'Dislikes, ' : '' )+ (post.comments_off? 'Comments ' : '' )"
                      class="lockIcon">
                lock
            </mat-icon>
            <button (cdkCopyToClipboardCopied)="this.snackbarService.openSuccessSnackBar('Link to post successfully copied to clipboard');"
                    *ngIf="!reducedContent" [cdkCopyToClipboard]="urlOrigin + '/feed/' + post.id"
                    class="post-action-btn specialSmallBtn"
                    mat-button
                    matTooltip="Copy share link for post">
                <mat-icon>link</mat-icon>
            </button>
            <button *ngIf="post.original_post?.id && !reducedContent" [routerLink]="['/feed', post.original_post?.id]"
                    class="post-action-btn"
                    mat-button
                    matTooltip="View parent post">
                View Related Post
            </button>
            <button
                    (click)="likePost(post)"
                    [class.empty-state]="!post.likes_count"
                    [class.mat-mdc-raised-button]="post.is_liked && community?.like_post_button_bg_color_hex ? community?.like_post_button_bg_color_hex: ''"
                    [disabled]="post.likes_off || !(isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member']))"
                    [matTooltip]="post.likes_off ?'Likes have been disabled for this post': 'Like post'"
                    [style.background-color]="post.is_liked ?community?.like_post_button_bg_color_hex: ''"
                    [style.color]="post.is_liked ?this.themeService.getReadableColor(community?.like_post_button_bg_color_hex): ''"
                    mat-button>
                <mat-icon [@likeAnimation]="post.is_liked ? 'active' : 'inactive'">thumb_up</mat-icon>
                {{ post.likes_count }}
            </button>
            <button
                    (click)="dislikePost(post)"
                    [class.empty-state]="!post.dislikes_count"
                    [class.mat-mdc-raised-button]="post.is_disliked && community?.dislike_post_button_bg_color_hex ? community?.dislike_post_button_bg_color_hex: ''"
                    [disabled]="post.dislikes_off || !(isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member']))"
                    [matTooltip]="post.dislikes_off?' Dislikes have been disabled for this post': 'Dislike post'"
                    [style.background-color]="post.is_disliked ?community?.dislike_post_button_bg_color_hex: ''"
                    [style.color]="post.is_disliked? this.themeService.getReadableColor(community?.dislike_post_button_bg_color_hex): ''"
                    mat-button>
                <mat-icon [@likeAnimation]="post.is_disliked ? 'active' : 'inactive'">thumb_down</mat-icon>
                {{ post.dislikes_count }}
            </button>
            <button (click)="viewComments(post)" [class.empty-state]="!post.comments_count"
                    [class.mat-mdc-raised-button]="community?.view_comment_button_bg_color_hex"
                    [disabled]="post.comments_off"
                    [matTooltip]="post.comments_off ?' Comments have been disabled for this post': 'View comments'"
                    [style.background-color]="!post.comments_off? community?.view_comment_button_bg_color_hex: ''"
                    [style.color]="!post.comments_off? this.themeService.getReadableColor(community?.view_comment_button_bg_color_hex) : ''"
                    class="post-action-btn"
                    mat-button>
                <mat-icon *ngIf="!post.comments_off">comment</mat-icon>
                <mat-icon *ngIf="post.comments_off">speaker_notes_off</mat-icon>
                {{ post.comments_count }}
            </button>
        </div>
    </mat-card-actions>
</mat-card>

<ng-template #anonymous>
    <div class="miniInitial" mat-card-avatar matTooltip="This post was posted anonymously">A
    </div>
</ng-template>
